import React, { PureComponent } from 'react';
import IntersectionVisible from 'react-intersection-visible';

import classes from './ExtendImage.css';

class ExtendImage extends PureComponent {

    state = {
        width: 0
    }

    onInViewPort = () => {
       this.setState({width: "100%"});
    }

    onOutViewPort = () => {
        this.setState({width: 0});
    }

    render () {
        const delay = this.props.delay ? this.props.delay : "0.3s";

        return (
            <IntersectionVisible 
            onShow={() => this.onInViewPort()} 
            onHide={() => this.onOutViewPort()}
            className={classes.BackImage}>
                
                <div style={{width: this.state.width, transition: "1s " + delay + " width cubic-bezier(0.175, 0.885, 0.32, 1.275)", overflow: "hidden"}}>
                    {this.props.children}
                </div>

            </IntersectionVisible>
        );
    }
}

export default ExtendImage;


// WEBPACK FOOTER //
// ./client/src/components/ExtendImage/ExtemdImage.js